import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';
import { Logging } from '@newrelic/browser-agent/features/logging'
import storageService from '@/services/storage.service'; // Adjust the import path as needed
import { StorageKeys } from './enum';
let agent: BrowserAgent | null = null;
let isInitialized = false;

export const initNewRelic = (config: {
    licenseKey: string;
    applicationID: string;
    release?: {
        name: string;
        version: string;
    };
}) => {
    if (isInitialized || typeof window === 'undefined') return;
    agent = new BrowserAgent({
        init: {
            metrics: { enabled: false },
            page_view_timing: { enabled: false },
            session_trace: { enabled: false },

            // Enable only what we need
            jserrors: { enabled: true },
            page_action: { enabled: true }, // Required for custom events

            // Basic required configuration
            privacy: { cookies_enabled: true },
            ajax: {
                enabled: false, // Disable AJAX monitoring
                deny_list: ["bam.nr-data.net"]
            },
            distributed_tracing: { enabled: false }
        },
        info: {
            beacon: 'bam.nr-data.net',
            errorBeacon: 'bam.nr-data.net',
            licenseKey: config.licenseKey,
            applicationID: config.applicationID
        },
        loader_config: {
            accountID: "4686320", trustKey: "4686320", agentID: "1134517327", licenseKey: config.licenseKey, applicationID: config.applicationID
        },
        features: [
            Logging
        ]
    });

    if (config.release) {
        // Note: The npm package might handle releases differently
        // You may need to use setCustomAttribute instead
        agent.setCustomAttribute('releaseName', config.release.name);
        agent.setCustomAttribute('releaseVersion', config.release.version);
    }

    isInitialized = true;
};

export const trackEvent = (eventName: string, attributes: Record<string, any> = {}) => {
    if (!agent) return;

    try {
        // Use localStorage directly to avoid reactivity
        const userData = localStorage.getItem(StorageKeys.user);
        const user = userData ? JSON.parse(userData) : null;
        
        const eventAttributes = {
            ...attributes,
            ...(user?._id && { userId: user._id })
        };

        agent.addPageAction(eventName, eventAttributes);
    } catch (e) {
        console.error('Tracking failed:', e);
    }
};

export const trackError = (error: Error | string, context: Record<string, any> = {}) => {
    if (agent) {
        try {
            const err = typeof error === 'string' ? new Error(error) : error;
            agent.noticeError(err, context);
            agent.setCustomAttribute('lastTrackedError', err.message);
        } catch (e) {
            console.error('New Relic error tracking failed:', e);
        }
    }
};

export const startInteraction = (name: string, attributes: Record<string, any> = {}) => {
    if (!agent) return null;

    const interaction = agent.interaction();
    interaction.setAttribute('interactionName', name);
    Object.entries(attributes).forEach(([key, value]) => {
        interaction.setAttribute(key, value);
    });
    return interaction;
};

export const endInteraction = (interaction: any) => {
    if (agent && interaction) {
        interaction.end();
    }
};

